import { CompetitionStageDto, type PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";

// Two-stage events (begrenset anbudskonkurranse) have no tilbudsfrist until the invitation —
// during stage 1 the request deadline is the phase-relevant deadline the portal shows. During
// the qualification window (requests closed, invitation pending) there is no active deadline.
export const effectiveDeadlineIso = (event: PortalSourcingEventDetailDto): string | null => {
  if (event.competitionStage === CompetitionStageDto.Qualification) return null;
  return event.bidSubmissionDeadline ?? event.requestDeadline ?? null;
};

// Phase comes from the server-derived competitionStage — never inferred from which deadline
// fields happen to be null (that inference breaks for procedures where both coexist, e.g. DPS).
export const isRequestPhase = (event: PortalSourcingEventDetailDto): boolean =>
  event.competitionStage === CompetitionStageDto.RequestsOpen;
